export enum ClassroomActionType {
  CLASSROOMS_REQUEST_SUCCESS = 'CLASSROOMS.REQUEST_SUCCESS'
}
